import React from 'react'
import { Switch as SwitchAnt } from 'antd'
import { SwitchProps } from 'antd/lib/switch'

function Switch({ disabled = true, ...props }: SwitchProps) {
  return <SwitchAnt {...props} disabled={disabled} />
}

export default Switch
